<template>
    <section id="CTABanner">
        <div class="container content-transform">
            <div
                class="content title-container"
                v-if="!onlyBanner && addTopBanner === false"
            >
                <div class="row mx-2 mx-lg-0">
                    <div class="col-12 col-lg-6 align-center mb-3 mb-lg-0">
                        <div v-if="topBannerData.extraTextBtn">
                            <div class="buttons">
                                <a
                                    :href="topBannerData.href"
                                    class="button"
                                    :rel="
                                        isExternal
                                            ? 'noopener noreferrer'
                                            : null
                                    "
                                    :target="isExternal ? '_blank' : null"
                                >
                                    <label class="m-0 mr-2">{{
                                        topBannerData.extraTextBtn
                                    }}</label>
                                    <div v-if="topBannerData.extraBtnSvg">
                                        <svg
                                            class="svg-hover-white"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                id="play_circle_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
                                                d="M89-862.6l8.4-5.4L89-873.4Zm3,6.6a11.684,11.684,0,0,1-4.68-.945,12.119,12.119,0,0,1-3.81-2.565,12.118,12.118,0,0,1-2.565-3.81A11.685,11.685,0,0,1,80-868a11.685,11.685,0,0,1,.945-4.68,12.119,12.119,0,0,1,2.565-3.81,12.119,12.119,0,0,1,3.81-2.565A11.684,11.684,0,0,1,92-880a11.684,11.684,0,0,1,4.68.945,12.119,12.119,0,0,1,3.81,2.565,12.119,12.119,0,0,1,2.565,3.81A11.685,11.685,0,0,1,104-868a11.685,11.685,0,0,1-.945,4.68,12.118,12.118,0,0,1-2.565,3.81,12.119,12.119,0,0,1-3.81,2.565A11.684,11.684,0,0,1,92-856Zm0-2.4a9.265,9.265,0,0,0,6.81-2.79A9.266,9.266,0,0,0,101.6-868a9.265,9.265,0,0,0-2.79-6.81A9.265,9.265,0,0,0,92-877.6a9.265,9.265,0,0,0-6.81,2.79A9.265,9.265,0,0,0,82.4-868a9.266,9.266,0,0,0,2.79,6.81A9.265,9.265,0,0,0,92-858.4ZM92-868Z"
                                                transform="translate(-80 880)"
                                                fill="#fff"
                                            />
                                        </svg>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div v-else-if="!topBannerData.extraTextBtn">
                            <h2 class="gtitle text-center fw-bold">
                                {{ topBannerData.title }}
                            </h2>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6 align-center">
                        <div class="buttons mt-2 mt-lg-0 text-center">
                            <a
                                :href="topBannerData.href"
                                class="button"
                                :rel="isExternal ? 'noopener noreferrer' : null"
                                :target="isExternal ? '_blank' : null"
                            >
                                <label class="m-0 mr-2">{{
                                    topBannerData.textBtn
                                }}</label>
                                <div v-if="topBannerData.btnSvg">
                                    <svg
                                        class="svg-hover-white"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            id="play_circle_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
                                            d="M89-862.6l8.4-5.4L89-873.4Zm3,6.6a11.684,11.684,0,0,1-4.68-.945,12.119,12.119,0,0,1-3.81-2.565,12.118,12.118,0,0,1-2.565-3.81A11.685,11.685,0,0,1,80-868a11.685,11.685,0,0,1,.945-4.68,12.119,12.119,0,0,1,2.565-3.81,12.119,12.119,0,0,1,3.81-2.565A11.684,11.684,0,0,1,92-880a11.684,11.684,0,0,1,4.68.945,12.119,12.119,0,0,1,3.81,2.565,12.119,12.119,0,0,1,2.565,3.81A11.685,11.685,0,0,1,104-868a11.685,11.685,0,0,1-.945,4.68,12.118,12.118,0,0,1-2.565,3.81,12.119,12.119,0,0,1-3.81,2.565A11.684,11.684,0,0,1,92-856Zm0-2.4a9.265,9.265,0,0,0,6.81-2.79A9.266,9.266,0,0,0,101.6-868a9.265,9.265,0,0,0-2.79-6.81A9.265,9.265,0,0,0,92-877.6a9.265,9.265,0,0,0-6.81,2.79A9.265,9.265,0,0,0,82.4-868a9.266,9.266,0,0,0,2.79,6.81A9.265,9.265,0,0,0,92-858.4ZM92-868Z"
                                            transform="translate(-80 880)"
                                            fill="#fff"
                                        />
                                    </svg>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            :class="{
                'cta-blue-banner-only': onlyBanner === true,
                'cta-blue': onlyBanner === false,
                'only-blue-banner': addTopBanner === false,
            }"
        >
            <div class="container d-flex justify-content-end w-100">
                <a
                    class="d-flex align-items-center font-weight-bold"
                    :href="bannerData.href"
                    :rel="isExternal ? 'noopener noreferrer' : null"
                    :target="isExternal ? '_blank' : null"
                >
                    <span class="mr-2 text-uppercase">{{
                        bannerData.bannerText
                    }}</span>
                    <svg
                        class="svg-hover"
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="30"
                        viewBox="0 0 16 30"
                    >
                        <path
                            id="Caret"
                            d="M13.541,1.556a2,2,0,0,1,2.918,0L26.843,12.632A2,2,0,0,1,25.384,16H4.616a2,2,0,0,1-1.459-3.368Z"
                            transform="translate(16) rotate(90)"
                            fill="#fff"
                        />
                    </svg>
                </a>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    props: {
        onlyBanner: {
            type: Boolean,
            default: false,
        },
        addTopBanner: {
            type: Boolean,
            default: true,
        },
        twoButtons: {
            type: Boolean,
            default: false,
        },
        bannerData: {
            type: Object,
            default: () => ({}),
        },
        topBannerData: {
            type: Object,
            default: () => ({}),
        },
        isExternal: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
